var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelchair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-wheelchair-6218921",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_247954",
    "data-name": "Path 247954",
    d: "M399.525,61.608a1.418,1.418,0,1,1-1.418-1.418,1.418,1.418,0,0,1,1.418,1.418",
    transform: "translate(-393.782 -60.19)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247955",
    "data-name": "Path 247955",
    d: "M164.888,472.369a.407.407,0,0,0-.525.237,3.36,3.36,0,1,1-4.395-4.3.408.408,0,0,0-.3-.757,4.176,4.176,0,0,0,1.544,8.052,4.254,4.254,0,0,0,.531-.033,4.168,4.168,0,0,0,3.386-2.671.408.408,0,0,0-.237-.525Z",
    transform: "translate(-157.043 -463.599)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247956",
    "data-name": "Path 247956",
    d: "M487.745,331.7a.426.426,0,0,0-.561-.122l-.731.421-1.358-2.049a.976.976,0,0,0-.81-.421h-2.691v-1.275h2.362a.38.38,0,1,0,0-.758h-2.362v-1.2a.409.409,0,0,0-.815,0V329.7a.6.6,0,0,0,.625.581h2.882a.14.14,0,0,1,.116.06l1.458,2.2a.619.619,0,0,0,.388.261.679.679,0,0,0,.145.016.657.657,0,0,0,.328-.087l.893-.515a.364.364,0,0,0,.132-.522Z",
    transform: "translate(-476.806 -322.978)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.c4ab7a4804e67eb68fe9ffeda5327284.svg";
export { ForwardRef as ReactComponent };